/* Converted to vanilla JS */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.control-navigation-bar li').forEach(function (li) {
        li.addEventListener('mouseenter', function () {
            var navDropdown = li.querySelector('.navigation-dropdown');
            if (navDropdown) navDropdown.classList.add('active');
        });
        li.addEventListener('mouseleave', function () {
            var navDropdown = li.querySelector('.navigation-dropdown');
            if (navDropdown) navDropdown.classList.remove('active');
        });
    });

    var navigateTo = document.getElementById('navigateTo');
    if (navigateTo) {
        navigateTo.addEventListener('change', function () {
            var newUrl = navigateTo.value;
            if (newUrl && newUrl !== '') window.location.href = newUrl;
        });
    }
});


